<template>
  <div
    class="uk-child-width-expand@s uk-child-width-1-3@m uk-child-width-1-3@l uk-grid-small"
    uk-grid
  >
    <div>
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'green'"
        :data="String(companyCounts.active || 0)"
        :subtitle="`Perusahaan`"
        :status="'Aktif'"
        :route-name="'CompanyData'"
        :query-params="{ status: 'active' }"
      />
    </div>
    <div>
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'red'"
        :data="String(companyCounts.inactive || 0)"
        :subtitle="`Perusahaan`"
        :status="'Tidak Aktif'"
        :route-name="'CompanyData'"
        :query-params="{ status: 'inactive' }"
      />
    </div>
  </div>
</template>

<script>
import CardStatus from '@/components/globals/card/CardStatus'

export default {
  components: {
    CardStatus
  },
  props: {
    isLoading: {
      required: false,
      type: Boolean
    },
    companyCounts: {
      required: false,
      type: Object,
      default: () => ({})
    }
  }
}
</script>
